<template>
  <div class="customer-demand-analysis">
    <div class="title">客户需求分析详情
      <div class="seach">
        <el-select v-model="query.custNo" @change="custNoChange" clearable filterable remote reserve-keyword placeholder="请输入客户关键词" :remote-method="remoteMethod" :loading="selectLoading">
          <el-option v-for="item in custList" :key="item.id" :label="item.deptName" :value="item.id">
          </el-option>
        </el-select>
        <el-date-picker v-model="query.seachTime" @change="seachTimeChange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
    </div>
    <template v-loading="selectLoading">
    <div class="top-stats">
      <el-card>
        <p>区间内累计发货量</p>
        <p class="big-number">{{ formData.planTotalWeight }} 万吨</p>
      </el-card>
      <el-card>
        <p>月均发货量</p>
        <p class="big-number">{{ formData.avgWeight }} 万吨</p>
      </el-card>
      <el-card>
        <p>区间末库存量</p>
        <p class="big-number">{{ formData.stockWeight }} 万吨</p>
      </el-card>
    </div>
    <div class="chart-container">
      <h3>发货趋势分析</h3>
      <div ref="trendChart" class="chart" style="width: 100%; height: 310px;"></div>
    </div>
    <div class="bottom-charts">
      <div class="chart-item">
        <h3>月度发货规律</h3>
        <div ref="monthlyRuleChart" class="chart" style="width: 100%; height: 310px;"></div>
      </div>
      <div class="chart-item">
        <h3>发货量分布</h3>
        <div ref="distributionChart" class="chart" style="width: 100%; height: 310px;"></div>
      </div>
    </div>
    </template>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { planStockAmountTotal, planExecuteAmountByMonth, planExecuteAmountDistribute } from "./api";
import { getRequset } from "@/basic-common/util/common.js";
import {getSettingDate} from "@/util/date";

export default {
  data () {
    return {
      enterprise: 'shanxi',
      dateRange: ['2023-01-01', '2023-12-31'],
      trendChart: null,
      monthlyRuleChart: null,
      distributionChart: null,
      formData: {},
      query: {
        seachTime:[getSettingDate("daySLast7"),getSettingDate("dayE")],
        startTime:getSettingDate("daySLast7"),
        endTime:getSettingDate("dayE")

      },
      custList: [],
      loading: false,
      selectLoading: false,
    }
  },
  mounted () {
    this.refresh()

  },
  methods: {
    refresh () {
        this.selectLoading = true
      this.getPlanStockAmountTotal() //顶部汇总
      this.getPlanExecuteAmountByMonth()  // 发货趋势分析、月度发货规律
      this.getPlanExecuteAmountDistribute() // 发货量分布
    },
    //获取数据
    getPlanStockAmountTotal () {
      planStockAmountTotal(this.query).then(({ data }) => {
        this.formData = data.data
      })
    },
    // 发货趋势分析、月度发货规律
    getPlanExecuteAmountByMonth () {
      planExecuteAmountByMonth(this.query).then(({ data: { data } }) => {
        this.initTrendChart(data)  // 发货趋势分析
        this.initMonthlyRuleChart(data)  // 月度发货规律
      })
    },
    // 发货量分布
    getPlanExecuteAmountDistribute () {
      planExecuteAmountDistribute(this.query).then(({ data: { data } }) => {
        this.initDistributionChart(data) // 发货量分布
        this.selectLoading = false
      })
    },

    initTrendChart ({ data, title }) {
      this.trendChart = echarts.init(this.$refs.trendChart)
      const option = {
        xAxis: {
          type: 'category',
          data: title,
        },
        yAxis: {
          type: 'value',
          name: '发货量(万吨)',
        },
        series: [
          {
            data: data,
            type: 'line',
            smooth: true,
          },
        ],
      }
      this.trendChart.setOption(option)
    },
    initMonthlyRuleChart ({ data, title }) {
      this.monthlyRuleChart = echarts.init(this.$refs.monthlyRuleChart)
      const option = {
        polar: {},
        angleAxis: {
          type: 'category',
          data: title,
        },
        radiusAxis: {
          min: 0,
          max: 30,
        },
        series: [
          {
            type: 'line',
            data: data,
            coordinateSystem: 'polar',
            connectNulls: true,
          },
        ],
        legend: {
          show: false,
        },
      }
      this.monthlyRuleChart.setOption(option)
    },
    initDistributionChart ({ data, title }) {
      this.distributionChart = echarts.init(this.$refs.distributionChart)
      const option = {
        xAxis: {
          type: 'category',
          data: title,
        },
        yAxis: {
          type: 'value',
          name: '频次',
        },
        series: [
          {
            data: data,
            type: 'bar',
            itemStyle: {
              color: '#2f89cf',
            },
          },
        ],
      }
      this.distributionChart.setOption(option)
    },
    async remoteMethod (query) {
      if (query !== '') {
        this.selectLoading = true;
        const { data } = await getRequset(`/api/produce/blade-dept/select/distinct/select?deptName=${query}`)
        this.custList = Array.isArray(data) ? data : []
        this.selectLoading = false
      } else {
        this.custList = [];
      }
    },
    seachTimeChange (value) {
      if (value) {
        this.$set(this.query, 'startTime', value[0])
        this.$set(this.query, 'endTime', value[1])
      } else {
        this.$set(this.query, 'startTime', '')
        this.$set(this.query, 'endTime', '')
      }
      this.refresh()
    },
    custNoChange () {
      this.refresh()
    }
  },
  beforeDestroy () {
    if (this.trendChart) {
      this.trendChart.dispose()
    }
    if (this.monthlyRuleChart) {
      this.monthlyRuleChart.dispose()
    }
    if (this.distributionChart) {
      this.distributionChart.dispose()
    }
  },
}
</script>

<style scoped lang="scss">
.customer-demand-analysis {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  overflow: scroll;
  padding-bottom: 40px;

  .title {
    font-size: 24px;
    color: #000;
    font-weight: 600;
    margin-bottom: 15px;
  }
  .seach {
    display: inline-block;
    float: right;
  }
}
.top-stats {
  width: 100%;
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
}
.top-stats .el-card {
  width: 30%;
  text-align: center;
}
.big-number {
  font-size: 1.5em;
  font-weight: bold;
  margin-top: 10px;
}
.el-select,
.el-date-picker {
  margin-right: 10px;
  margin-bottom: 20px;
}
.chart-container,
.bottom-charts {
  margin-bottom: 20px;
}
.bottom-charts {
  display: flex;
  justify-content: space-between;
}
.chart-item {
  width: 48%;
}
</style>
